import PhotoSwipeLightbox from 'photoswipe/lightbox';
import PhotoSwipe from 'photoswipe';

export function initPhotoSwipeLightbox() {
  const arrowPrevSvg = '<svg aria-hidden="true" focusable="false" class="svg-inline--fa" role="img" xmlns="http://www.w3.org/2000/svg" height="1em" viewBox="0 0 448 512"><path fill="currentColor" d="M18.2 273l-17-17 17-17L171.8 85.4l17-17 33.9 33.9-17 17L93.1 232 424 232l24 0 0 48-24 0L93.1 280 205.8 392.6l17 17-33.9 33.9-17-17L18.2 273z"/></svg>';
  const arrowNextSvg = '<svg aria-hidden="true" focusable="false" class="svg-inline--fa" role="img" xmlns="http://www.w3.org/2000/svg" height="1em" viewBox="0 0 448 512"><path fill="currentColor" d="M429.8 273l17-17-17-17L276.2 85.4l-17-17-33.9 33.9 17 17L354.9 232 24 232 0 232l0 48 24 0 330.8 0L242.2 392.6l-17 17 33.9 33.9 17-17L429.8 273z"/></svg>';
  const zoomSvg = '<svg aria-hidden="true" focusable="false" class="svg-inline--fa" role="img" xmlns="http://www.w3.org/2000/svg" height="1em" viewBox="0 0 512 512"><path fill="currentColor" d="M416 208c0 45.9-14.9 88.3-40 122.7L502.6 457.4c12.5 12.5 12.5 32.8 0 45.3s-32.8 12.5-45.3 0L330.7 376c-34.4 25.2-76.8 40-122.7 40C93.1 416 0 322.9 0 208S93.1 0 208 0S416 93.1 416 208zM184 296c0 13.3 10.7 24 24 24s24-10.7 24-24V232h64c13.3 0 24-10.7 24-24s-10.7-24-24-24H232V120c0-13.3-10.7-24-24-24s-24 10.7-24 24v64H120c-13.3 0-24 10.7-24 24s10.7 24 24 24h64v64z"/></svg>';
  const closeSvg = '<svg aria-hidden="true" focusable="false" class="svg-inline--fa" role="img" xmlns="http://www.w3.org/2000/svg" height="1em" viewBox="0 0 384 512"><path fill="currentColor" d="M342.6 150.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L192 210.7 86.6 105.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3L146.7 256 41.4 361.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0L192 301.3 297.4 406.6c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L237.3 256 342.6 150.6z"/></svg>';
  const downloadSvg = '<svg aria-hidden="true" focusable="false" class="svg-inline--fa" role="img" xmlns="http://www.w3.org/2000/svg" height="1em" viewBox="0 0 640 512"><path fill="currentColor" d="M144 480C64.5 480 0 415.5 0 336c0-62.8 40.2-116.2 96.2-135.9c-.1-2.7-.2-5.4-.2-8.1c0-88.4 71.6-160 160-160c59.3 0 111 32.2 138.7 80.2C409.9 102 428.3 96 448 96c53 0 96 43 96 96c0 12.2-2.3 23.8-6.4 34.6C596 238.4 640 290.1 640 352c0 70.7-57.3 128-128 128H144zm79-167l80 80c9.4 9.4 24.6 9.4 33.9 0l80-80c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-39 39V184c0-13.3-10.7-24-24-24s-24 10.7-24 24V318.1l-39-39c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9z"/></svg>';

  const previewLightbox = new PhotoSwipeLightbox({
    gallery: '.js-image-gallery',
    children: 'a.product-img',
    arrowPrevSVG: arrowPrevSvg,
    arrowNextSVG: arrowNextSvg,
    zoomSVG: zoomSvg,
    closeSVG: closeSvg,
    pswpModule: PhotoSwipe,
    showHideAnimationType: 'fade',
    tapAction: (pt, evt) => {
      if (evt.target.classList.contains('pswp__img')) {
        pswp.next();
      } else {
        pswp.close();
      }
    },
  });

  previewLightbox.on('uiRegister', function () {
    previewLightbox.pswp.ui.registerElement({
      name: 'custom-caption',
      order: 9,
      isButton: false,
      appendTo: 'root',
      html: 'Caption text',
      onInit: (el, pswp) => {
        previewLightbox.pswp.on('change', () => {
          const currSlideElement = previewLightbox.pswp.currSlide.data.element;

          let captionHTML = '';

          if (currSlideElement) {
            const hiddenCaption = currSlideElement.querySelector('.hidden-caption-content');

            if (hiddenCaption) {
              // get caption from element with class hidden-caption-content
              captionHTML = hiddenCaption.innerHTML;
            } else {
              // get caption from alt attribute
              captionHTML = currSlideElement.querySelector('img').getAttribute('alt');
            }
          }

          el.innerHTML = captionHTML || '';
        });
      }
    });
  });

  previewLightbox.init();

  jQuery(document).on('click', '[data-pswp-trigger]', (e) => {
    e.preventDefault();

    const $galleryTrigger = document.querySelector(`${e.currentTarget.dataset.pswpTrigger} a.product-img:nth-of-type(1)`);

    if ($galleryTrigger) {
      $galleryTrigger.click();
    }
  });

  jQuery('.product-visual').each(function () {
    const holder = jQuery(this);
    const btnOpen = holder.find('.btn-magnification');

    btnOpen.on('click', function (e) {
      e.preventDefault();
      const activeSlide = holder.find('.swiper-product-visual .swiper-slide-active .product-img');

      activeSlide[0].click();
    });
  });

  const options = {
    gallery: '#main',
    children: 'a[data-pswp-trigger]',
    arrowPrevSVG: arrowPrevSvg,
    arrowNextSVG: arrowNextSvg,
    zoomSVG: zoomSvg,
    closeSVG: closeSvg,
    pswpModule: PhotoSwipe,
  };
  const lightbox = new PhotoSwipeLightbox(options);
  lightbox.on('uiRegister', function () {
    // add a custom download button, hidden by default
    lightbox.pswp.ui.registerElement({
      name: 'download-button',
      order: 8,
      isButton: true,
      tagName: 'a',
      html: downloadSvg,

      onInit: (el, pswp) => {
        el.setAttribute('download', '');
        el.setAttribute('target', '_blank');
        el.setAttribute('rel', 'noopener');
        el.classList.add('d-none');

        pswp.on('change', () => {
          el.classList.add('d-none');
          if (pswp.currSlide.data.element.dataset.pswpDownload) {
            // only show the download button if the data attribute is set
            el.classList.remove('d-none');
            el.href = pswp.currSlide.data.element.dataset.pswpDownload;
          }
        });
      }
    });
  });
  lightbox.addFilter('itemData', (itemData, index) => {
    if (itemData.element.dataset.pswpType && itemData.element.dataset.pswpType === 'preview-video') {
      // set a custom parameter to use for the iframe
      const previewUrl = itemData.element.href;

      if (previewUrl) {
        itemData.previewUrl = previewUrl;
      }
    }
    return itemData;
  });
  lightbox.on('contentLoad', (e) => {
    const { content } = e;

    if (content.type === 'preview-video') {
      e.preventDefault();

      // Create a container for iframe
      // and assign it to the `content.element` property
      content.element = document.createElement('div');
      content.element.className = 'pswp__preview-container video-lightbox';

      const iframe = document.createElement('iframe');

      iframe.setAttribute('allow', 'xr-spatial-tracking; fullscreen; autoplay');
      iframe.setAttribute('referrerpolicy', 'no-referrer-when-downgrade');
      iframe.setAttribute('frameBorder', '0');
      iframe.setAttribute('width', '100%');
      iframe.setAttribute('height', '100%');
      iframe.src = content.data.previewUrl;
      content.element.appendChild(iframe);
    }
  });
  lightbox.on('contentDeactivate', (e) => {
    const { content } = e;
    if (content.type === 'preview-video') {
      // if the slide deactivates, pause the video
      let iframe = content.element.querySelector('iframe');
      if (iframe.contentWindow) {
        iframe.contentWindow.postMessage(messageFn('pause', iframe.src), '*');
      }
    }
  });
  lightbox.on('contentActivate', (e) => {
    const { content } = e;
    if (content.type === 'preview-video') {
      // if the slide deactivates, play the video
      let iframe = content.element.querySelector('iframe');
      if (iframe.contentWindow) {
        iframe.contentWindow.postMessage(messageFn('play', iframe.src), '*');
      }
    }
  });
  lightbox.on('contentAppend', ({ content }) => {
    if (content.type === 'preview-video' && !content.slide.isActive) {
      // by default autoplay is set, but should be removed if the active slide isn't the video
      let iframe = content.element.querySelector('iframe');
      if (iframe.src) {
        iframe.src = iframe.src.replace('autoplay=1', '');
      }
    }
  });
  lightbox.init();

  jQuery('.gallery').each(function(i, gallery) {
    const swiperCarousel = gallery.querySelector('.swiper-carousel');

    if (swiperCarousel) {
      const swiper = swiperCarousel.swiper;
      lightbox.on('change', () => {
        const { pswp } = lightbox;
        if (swiper.slides.length - 1 >= pswp.currIndex) {
          swiper.slideTo(pswp.currIndex, 0, false);
        }
      });
    }
  });

  function messageFn(action, src) {
    if (src.search("vimeo") > 0) { // case for Vimeo
      return JSON.stringify({
        method: action
      });
    } else if (src.search("youtube") > 0) { // case for YouTube
      return JSON.stringify({
        event: 'command',
        func: action + 'Video'
      });
    } else if (src.search("v.qq") > 0) { // case for YouTube
      return 'bind' + action;
    } else { // case for other video services (hurriyet videos, dailymotion etc..)
      return action;
    }
  }
}

export function initIframeSwipeLightbox() {
  const previewLightbox = new PhotoSwipeLightbox({
    gallery: '.js-preview-image',
    children: false,
    mainClass: 'video-lightbox',
    pswpModule: PhotoSwipe
  });

  // parse data-preview-url attribute
  previewLightbox.addFilter('itemData', (itemData, index) => {
    const previewUrl = itemData.element.href;

    if (previewUrl) {
      itemData.previewUrl = previewUrl;
    }
    return itemData;
  });

  // override slide content
  previewLightbox.on('contentLoad', (e) => {
    const { content } = e;

    if (content.type === 'preview-video') {
      e.preventDefault();

      // Create a container for iframe
      // and assign it to the `content.element` property
      content.element = document.createElement('div');
      content.element.className = 'pswp__preview-container';

      const iframe = document.createElement('iframe');

      iframe.setAttribute('allow', 'xr-spatial-tracking; fullscreen; autoplay');
      iframe.setAttribute('referrerpolicy', 'no-referrer-when-downgrade');
      iframe.setAttribute('frameBorder', '0');
      iframe.setAttribute('width', '100%');
      iframe.setAttribute('height', '100%');
      iframe.src = content.data.previewUrl;
      content.element.appendChild(iframe);
    }
  });

  previewLightbox.init();
}
